import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import DxDataGrid from 'devextreme/ui/data_grid';
import { Subscription } from 'rxjs';
import { DxToolbarPreparingEvent } from '../../../../core/dx.types';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { StateStoreService } from '../../../../shared/modules/my-common/services/state-store.service';
import { GridHelperService } from '../../../../shared/modules/ui/services/grid-helper.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, LoopBackAuth, Vehicle, VehicleService } from '../../../../shared/sdk';
import DataSourceOptions = DevExpress.data.DataSourceOptions;
import { HelperService } from '../../services/helper.service';
import { dxStoreLoadHooks } from 'src/app/shared/classes/loopback-custom-store/generic/store.utils';
import { tap } from 'rxjs/operators';
import { VehicleServiceAddFormComponent } from '../vehicle-service-form/vehicle-service-form.component';

@Component({
  selector: 'app-vehicle-service-grid',
  templateUrl: './vehicle-service-grid.component.html',
  styleUrls: ['./vehicle-service-grid.component.scss'],
})
export class VehicleServiceGridComponent implements OnInit, OnDestroy {
  dso: DataSourceOptions;
  grid_stateStoring: any;
  modifiedSubscription: Subscription;

  facilityDso: DataSourceOptions = [];

  _vehicleId: number | null = null;
  @Input()
  set vehicleId(v: number) {
    this._vehicleId = v;
    this.dso = this.buildDso();
  }
  get vehicleId() {
    return this._vehicleId;
  }

  @Output() mySelected: EventEmitter<Vehicle[]> = new EventEmitter<Vehicle[]>();

  @ViewChild(DxDataGridComponent, { static: true }) grid: DxDataGridComponent;

  constructor(
    private logger: LoggerService,
    public config: ConfigService,
    private ui: UiService,
    private dss: DataSourceService,
    private gridHelper: GridHelperService,
    protected dialog: MatDialog,
    public helperService: HelperService,
  ) {
    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '439b7e1f-9724-46cc-9083-b8a3108fc213',
    };
  }

  ngOnInit() {
    this.modifiedSubscription = this.dss.modifiedEvent.subscribe(modelName => {
      if ([Vehicle.getModelName()].includes(modelName)) {
        if (this.grid) {
          this.grid.instance.refresh();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.modifiedSubscription.unsubscribe();
  }

  repaint(): void {
    this.grid && this.grid.instance && this.grid.instance.repaint();
  }

  grid_onInitialized(e) {
    this.gridHelper.handle(e.component, {
      notifyErrors: true,
    });

    (e.component as DxDataGrid).deselectAll();
    this.mySelected.emit([]);
  }

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {
    e.toolbarOptions.items.unshift({
      name: 'newVehicle',
      locateInMenu: 'auto',
      widget: 'dxButton',
      location: 'after',
      sortIndex: 30,
      showText: 'inMenu',
      options: {
        icon: 'fas fa-plus',
        text: 'Change Vehicle Status to “In Maintenance”',
        hint: 'Change Vehicle Status to “In Maintenance”',
        onClick: this.grid_toolbar_newVehicle_onClick.bind(this),
      },
    });
  }

  grid_onSelectionChanged(event: any): void {
    const items = (event.component as DxDataGrid).getDataSource().items();

    if (items.find(i => event.currentSelectedRowKeys.includes(i.id))) {
      this.mySelected.emit(event.selectedRowsData);
    }
  }

  grid_toolbar_newVehicle_onClick() {
    this.ui
      .openEditDialog({
        modelId: null,
        ModelClass: VehicleService,
        title: 'Add Vehicle Service',
        FormComponentClass: VehicleServiceAddFormComponent,
      })
      .afterClosed()
      .pipe(tap(res => res && this.grid.instance.refresh()))
      .subscribe();
  }

  grid_onEditingStart(e: any): void {
    e.cancel = true;
    this.ui
      .openEditDialog({
        modelId: e.data.id,
        inputs: {},
        title: `Edit: ${e.data.vehicle.name}`,
        ModelClass: VehicleService,
        FormComponentClass: VehicleServiceAddFormComponent,
      })
      .afterClosed()
      .pipe(tap(res => res && this.grid.instance.refresh()))
      .subscribe();
  }

  buildDso() {
    const so = this.dss.getStoreOptions(VehicleService, null, false);
    so.noSql = true;
    so.customFilter = {
      where: { ...(this.vehicleId ? { 'vehicle.id': this.vehicleId } : {}) },
    };
    const store = new CustomStore(so);
    return { store } as DataSourceOptions;
  }
}
